import React, { useRef } from "react"
import {
  Wrapper,
  Paragraph,
} from "./ProductsDescription.style"
import { useDetectDevice } from "../../../lib/useDetectDevice"
import { buildHtmlFromString } from "../../../lib/buildHtmlFromString"

interface Props {
  id?: string
  data: string
  className?: string
}

export function ProductsDescriptionView({ id = "", data, className }: Props) {
  const isMobile = useDetectDevice()
  const classNames = (className && className) + " " + (isMobile && "mobile")
  if (!data) return <></>

  return (
    <Wrapper id={id} className={classNames} >
      {data && <Paragraph className={isMobile ? "mobile" : ""} >{buildHtmlFromString(data)}</Paragraph>}
    </Wrapper >
  )
}

